import {BaseService} from './BaseService';
import {ExamAfterProcessDAO} from '../DAO/ExamAfterProcessDAO';
import {ExamAfterProcessInitialDataDTOInterface} from '../DTO/ExamAfterProcessInitialDataDTOInterface';
import {UserDeliveryAddressDTOInterface} from '../DTO/UserDeliveryAddressDTOInterface';
import {ExamAfterProcessDTOInterface} from '../DTO/ExamAfterProcessDTOInterface';


export class ExamAfterProcessService extends BaseService {

	public async getInitialData(paymentId: number): Promise<ExamAfterProcessInitialDataDTOInterface|null> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.getInitialData(paymentId);

		return res;
	}

	public async saveExamAfterProcess(examAfterProcess: ExamAfterProcessDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.saveExamAfterProcess(examAfterProcess);

		return res;
	}

	public async registerMedicineDeliveryAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.registerMedicineDeliveryAddress(paymentId, data);

		return res;
	}

	public async updateHomeAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.updateHomeAddress(paymentId, data);

		return res;
	}

	public async updateMedicineDeliveryAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.updateMedicineDeliveryAddress(paymentId, data);

		return res;
	}

	public async deleteMedicineDeliveryAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.deleteMedicineDeliveryAddress(paymentId, data);

		return res;
	}

	public async registerPrescriptionDeliveryAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.registerPrescriptionDeliveryAddress(paymentId, data);

		return res;
	}

	public async updatePrescriptionDeliveryAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.updatePrescriptionDeliveryAddress(paymentId, data);

		return res;
	}

	public async deletePrescriptionDeliveryAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.deletePrescriptionDeliveryAddress(paymentId, data);

		return res;
	}

	public async registerStoreAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.registerStoreAddress(paymentId, data);

		return res;
	}

	public async updateStoreAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.updateStoreAddress(paymentId, data);

		return res;
	}

	public async deleteStoreAddress(paymentId: number, data: UserDeliveryAddressDTOInterface): Promise<ExamAfterProcessInitialDataDTOInterface> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.deleteStoreAddress(paymentId, data);

		return res;
	}

	public async createPaymentUrl(paymentId: number): Promise<{processUrl: string}> {
		const dao = new ExamAfterProcessDAO(this as BaseService);
		const res = await dao.createPaymentUrl(paymentId);

		return res;
	}
}
